import React, { FunctionComponent } from "react";
import { Demo } from "../components/demo";
import { ComponentProps } from "../components/component-props";

const dataTableCode =
`<DataTable>
    <DataTableContent>
        <DataTableHeaderRow>
            <DataTableColumnHeaderCell>Hero Name</DataTableColumnHeaderCell>
            <DataTableColumnHeaderCell>Email</DataTableColumnHeaderCell>
        </DataTableHeaderRow>
        <DataTableBody>
            <DataTableRow>
                <DataTableCell>Adora</DataTableCell>
                <DataTableCell><a href="#">adora@grayskull.org</a></DataTableCell>
            </DataTableRow>
            <DataTableRow>
                <DataTableCell>Swift Wind</DataTableCell>
                <DataTableCell><a href="#">horsey@eteria.org</a></DataTableCell>
            </DataTableRow>
        </DataTableBody>
    </DataTableContent>
</DataTable>`;

const dataTableDemo = {
    code: dataTableCode
};

export const DataTableDemo: FunctionComponent = () => {
    return (
        <Demo demo={dataTableDemo}>
            <ComponentProps componentName="DataTable" />
            <ComponentProps componentName="DataTableToolbar" />
            <ComponentProps componentName="DataTableToolbarBatchActions" />
            <ComponentProps componentName="DataTableToolbarPrimaryActions" />
            <ComponentProps componentName="DataTableContent" />
            <ComponentProps componentName="DataTableHeaderRow" />
            <ComponentProps componentName="DataTableColumnHeaderCell" />
            <ComponentProps componentName="DataTableHeaderCheckboxCell" />
            <ComponentProps componentName="DataTableColumnManageButton" />
            <ComponentProps componentName="DataTableBody" />
            <ComponentProps componentName="DataTableRow" />
            <ComponentProps componentName="DataTableCell" />
            <ComponentProps componentName="DataTableTotalRow" />
            <ComponentProps componentName="DataTableTotalCell" />
            <ComponentProps componentName="DataTableCheckboxCell" />
            <ComponentProps componentName="DataTableOverflowMenuCell" />
            <ComponentProps componentName="OverflowMenu" />
            <ComponentProps componentName="DataTablePagination" />
        </Demo>
    );
};
